import(/* webpackMode: "eager" */ "/opt/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.js\",\"import\":\"Cairo\",\"arguments\":[{\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\"],\"display\":\"swap\",\"subsets\":[\"arabic\"],\"variable\":\"--font-cairo\",\"adjustFontFallback\":true,\"preload\":true,\"fallback\":[\"Cairo Fallback\",\"system-ui\",\"-apple-system\",\"Segoe UI\",\"Roboto\",\"Helvetica Neue\",\"Arial\",\"Noto Sans Arabic\",\"sans-serif\"]}],\"variableName\":\"cairoFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/swiper/modules/grid.css");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/opt/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/auth/NextAuthProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/cart/cart-popup/index.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/local-switcher/index.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/next-image/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/fixed-box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/footer/news-letter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/GlobalConfig.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/Categories.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/navbar/responsive-side-menu/ResponsiveSideMenu.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/navbar/search.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/navbar/user-actions/account.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/navbar/user-actions/CartPopup.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/navbar/user-actions/wishlist.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/top-header/alerts.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/layout/header/top-header/links-list.js");
